<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">我的收藏</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="2" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="flex-box flex-between fs18 mb30">
                    <div class="col90">共有 <span class="fwb" :class="goodsList.length > 0 ? 'col12' : 'col90'">{{
                        goodsList.length
                    }}</span> 件商品</div>
                    <div class="flex-box mr45 delete col12 cursor " @click="delCollection">删除</div>
                </div>
                <div class="goods_list flex-box flex-wrap flex-col-start" v-if="goodsList.length > 0">
                    <div class="goods_item cursor" :class="item.isChoose ? 'active' : ''" v-for="(item, index) in goodsList"
                        :key="index" @click="onDetail(item.goods_id)">
                        <div class="goods_pic">
                            <img :src="item.goods.image_text" class="pic" alt="">
                            <i class="check cursor" @click.stop="chooseGoods(item)"></i>
                        </div>
                        <div class="coleb price"><span class="fs18 fwb">¥ {{ item.goods.price }}</span> <span
                                class="fs14">/{{ item.goods.unit }}</span></div>
                        <div class="m-ellipsis fs16 col27 fwb mb5">{{ item.goods.title }}</div>
                        <template v-for="(params, i) in item.goods.params_text" :key="i">
                            <div class="fs14 col96 m-ellipsis" v-if="i < 3">{{ params.title }}：{{ params.content }}</div>
                        </template>
                        <view class="fs24 col-96 lh32 mb10">
                        </view>
                    </div>
                </div>
                <div v-else class="nodata fs16 tc">
                    <img src="../../assets/static/icon/c_nodata.png" class="c_nodata" alt="">
                    <div>暂无收藏</div>
                </div>
                <pagination :sumCount="sumCount" :perCount="perCount" @pageTurn="pageTurn" v-show="sumCount > perCount">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "我的收藏-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            page: 1,
            sumCount: 0,
            perCount: 10,
            goodsList: [],
        };
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取列表
        getList() {
            this.$api.getCollection({
                type: 'favorite',
                page: this.page,
            }).then(res => {
                this.goodsList = res.data.data.map(item => ({
                    ...item,
                    isChoose: false
                }));
                this.sumCount = res.data.total;
                this.perCount = res.data.per_page;
            }).catch(err => {
                console.log(err)
            })
        },
        // 选中商品
        chooseGoods(item) {
            item.isChoose = !item.isChoose;
        },
        //取消收藏
        delCollection() {
            let ids = [];
            this.goodsList.forEach(item => {
                if (item.isChoose) {
                    ids.push(item.goods_id)
                }
            })
            if (ids.length <= 0) {
                this.$message({
                    customClass: 'custom-message',
                    message: "请选择商品",
                    type: "error",
                    duration: 3000,
                });
                return;
            }
            this.$confirm('确认取消收藏选中的商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.cancelCollection({
                    goods_ids: ids.join(',')
                }).then(res => {
                    this.$message({
                        customClass: 'custom-message',
                        type: 'success',
                        message: '取消收藏成功!'
                    });
                    this.getList(this.page);
                })
            }).catch((err) => {
                console.log(err)
            });
        },
        onDetail(id) {
            const routeData = this.$router.resolve({
                name: "FindProductDetail", // 目标路由的名称
                query: { id: id },
            });
            window.open(routeData.href, "_blank");
        },
        //分页
        pageTurn(e) {
            this.page = e + 1;
            this.getList();
        }
    },
};
</script>

<style lang="less" scoped>
.part_r {
    padding: 41px 44px 100px;
    background: #fff;

    .delete::before {
        display: block;
        content: "";
        width: 20px;
        height: 22px;
        display: block;
        margin-right: 12px;
        background: url('/src/assets/static/icon/c_add_del.png') no-repeat center;
        background-size: 100%;
    }

    .goods_item {
        width: 232px;
        height: 390px;
        border-radius: 8px;
        padding: 20px 20px 0;
        margin-right: 24px;
        margin-bottom: 20px;
        box-shadow: 0px 0px 30px rgba(218, 227, 234, 0.5), 0px 0px 10px rgba(218, 227, 234, 0.5);

        &:nth-of-type(4n) {
            margin-right: 0;
        }

        &:hover {
            transform: translate(0px, -10px);
        }

        &.active {
            .check {
                border: none;
                background: url("/src/assets/static/icon/c_default_add-on.png") no-repeat center;
                background-size: 100%;
            }
        }

        .goods_pic {
            width: 192px;
            height: 192px;
            border-radius: 8px;
            border: 1px solid rgba(98, 134, 171, 0.2);
            position: relative;
            overflow: hidden;
        }

        .pic {
            width: 190px;
            height: 190px;
            display: block;
            position: relative;
            z-index: 1;
            border-radius: 8px;
        }

        .check {
            border: 2px solid #333;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 2;


        }

        .price {
            margin: 13px 0 5px;
        }
    }

    .nodata {
        padding-top: 110px;
        height: 380px;
        color: #c9cdd4;

        .c_nodata {
            width: 263px;
            height: 166px;
            display: block;
            margin: 0 auto;
        }
    }
}
</style>
